export var IncomingMessageType;
(function (IncomingMessageType) {
    IncomingMessageType["UpdateSettings"] = "updateSettings";
    IncomingMessageType["IframeRequested"] = "iframeRequested";
    IncomingMessageType["IframeAppeared"] = "iframeAppeared";
    IncomingMessageType["IframeDisappeared"] = "iframeDisappeared";
    IncomingMessageType["ConsentPolicyChanged"] = "consentPolicyChanged";
})(IncomingMessageType || (IncomingMessageType = {}));
//# sourceMappingURL=incommingMessages.types.js.map